import { render, staticRenderFns } from "./ProjectUpdatesNavButtons.vue?vue&type=template&id=5098cba5"
import script from "./ProjectUpdatesNavButtons.vue?vue&type=script&lang=js"
export * from "./ProjectUpdatesNavButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports